import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { routeNames } from "../../constants/routeNames";
import { LoadingContext } from "../../context/LoadingContext";
import { TitleContext } from "../../context/TitleContext";
import "./SimplePages.css";
import { Button } from "react-bootstrap";

const ANDROID_APP_LINK =
  "https://play.google.com/store/apps/details?id=com.greeneking.orderandpay&hl=en_GB&pli=1";
const IOS_APP_LINK =
  "https://apps.apple.com/gb/app/greene-king-pubs-restaurants/id1297987541";

export const PreEntry = (props) => {
  const { setTitle } = useContext(TitleContext);
  const { setLoading } = useContext(LoadingContext);
  const [date, setDate] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const APP_STORE_LINK = /iPhone|iPad|iPod/i.test(navigator.userAgent)
    ? IOS_APP_LINK
    : ANDROID_APP_LINK;

  useEffect(() => {
    if (!location?.state?.redirected) {
      navigate(routeNames.LANDING);
    } else {
      setTitle("SORRY!");
      setLoading(false);
      setDate(location?.state?.data?.date);
    }
  }, []);

  const redirectToAppStore = () => {
    window.open(APP_STORE_LINK, "_blank");
  };

  return (
    <div className="simple-content ">
      <h2 className="simple-content-title">
        There isn’t a competition running at this time.{" "}
      </h2>

      <p className="simple-content-description mt-3">
        Come back soon for a chance to win epic prizes.
      </p>

      <p className="simple-content-description mt-3">
        In the meantime, head to the Greene King app for great offers.
      </p>

      <Button
        onClick={redirectToAppStore}
        className="cc-button entry-btn mb-0"
        style={{ marginTop: "32px" }}
        type="submit"
      >
        Get the app
      </Button>

      <p
        className="simple-content-description mb-0"
        style={{ fontWeight: "bold", marginTop: "32px" }}
      >
        Enjoy Coca-Cola{" "}
      </p>
    </div>
  );
};
